const createPostBookingMember = require('od-modules/helpers/membership/create_postbooking_member');
const createBasicFreeAccount = require('od-modules/helpers/membership/create_basic_free_account');
const getBooking = require('od-modules/helpers/membership/get_booking');
const updateBooking = require('od-modules/helpers/membership/update_booking');
const trackingUtils = require('od-modules/utils/tracking.utils');
const tagManagement = require('od-modules/utils/tag_management.utils');
const recaptchaPostBooking = require('od-modules/recaptcha/get_recaptcha_site_key');
const getRenewalOffer = require('od-modules/helpers/membership/get_renewal_offer');
const {eventConstants, genericConstants} = require('../../constants');
const {getEventType} = require('../../utils');

module.exports = Backbone.Model.extend({
    defaults: {
        data: null,
        traveller: '',
        userType: null,
        openRegisterForm: false,
        submitForm: false,
        displayConfirmationPage: false,
        displayErrorPage: false,
        updateBookingRequest: null,
        bookingIsUpdated: false,
        bookingDetailDTO: null,
        postBookingMembershipId: '',
        userDTO: null,
        eventType: '',
        recaptchaRendered: false,
        recaptchaWidgetID: null,
        siteKey: null,
        recaptchaResponse: null,
        token: null,
        offerPrice: null,
        membershipType: genericConstants.basicMembershipType,
        name: '',
        lastName: '',
        email: '',
        register: false,
    },

    currentAction: null,

    initialize() {
        this.bindEvents();
    },

    isPrimeFreeForAll() {
        return Odigeo.Membership.membershipPostBookingPage === 3;
    },

    bindEvents() {
        this.on('change:bookingDetailDTO', this.onBookingDetailDTOResponse.bind(this));
        this.on('change:postBookingMembershipId', this.onCreatePostBookingMember.bind(this));
    },

    url() {
        return this.currentAction.getUrl();
    },

    getDataRequestSettings(data) {
        return {
            data: data || null,
            dataType: 'json',
            contentType: 'application/json;charset=UTF-8',
            type: this.currentAction.getMethod(),
            error: this.errorRequest.bind(this),
        };
    },

    errorRequest(self, error) {
        if (self.isPrimeFreeForAll() && error.status === 400) {
            self.set('userType', 'PREMIUM');
            return self.displayConfirmationPage();
        }
        return self.displayErrorPage();
    },

    isRegistered: function() {
        return this.get('userType') === 'REGISTERED';
    },

    displayErrorPage() {
        this.set('displayErrorPage', true);
    },

    displayConfirmationPage() {
        this.set('displayConfirmationPage', true);
    },

    isBasicFreeAccount() {
        return this.get('membershipType') === genericConstants.basicFreeMembershipType;
    },

    createBasicFreeAccount(recaptchaResponse) {
        const postBookingRequest = this.buildPostBookingRequest(this.isBasicFreeAccount(), recaptchaResponse);
        this.currentAction = createBasicFreeAccount;
        this.fetch(this.getDataRequestSettings(createBasicFreeAccount.formatData(postBookingRequest)));
    },

    createPostBookingMember() {
        const postBookingRequest = this.buildPostBookingRequest(this.isBasicFreeAccount());
        this.currentAction = createPostBookingMember;
        this.fetch(this.getDataRequestSettings(createPostBookingMember.formatData(postBookingRequest)));
    },

    buildPostBookingRequest(isFreeAccount, recaptchaResponse) {
        const userDTO = this.get('userDTO');
        const bookingDetail = this.get('bookingDetailDTO');
        return {
            'email': isFreeAccount ? this.get('email') : userDTO.email,
            'name': isFreeAccount ? this.get('name') : Odigeo._.get(bookingDetail, 'buyer.name'),
            'lastNames': isFreeAccount ? this.get('lastName') : Odigeo._.get(bookingDetail, 'buyer.lastNames'),
            'monthsToRenewal': genericConstants.sixMonthsToRenewal,
            'membershipType': this.get('membershipType'),
            'channel': genericConstants.emailChannel,
            'balance': genericConstants.zeroBalance,
            'userId': isFreeAccount ? null : userDTO.id,
            'webSite': isFreeAccount ? null : Odigeo._.get(bookingDetail, 'bookingBasicInfo.website.code'),
            'recaptchaResponse': recaptchaResponse || null,
        };
    },

    getBooking() {
        const token = this.get('token');
        this.currentAction = getBooking;
        this.fetch(this.getDataRequestSettings(token));
    },

    getSubscriptionOffer() {
        this.currentAction = getRenewalOffer;
        this.fetch(this.getDataRequestSettings());
    },

    updateBooking(updateRequest) {
        const token = this.get('token');
        this.currentAction = updateBooking;
        const updateBookingRequest = updateBooking.formatUpdateBookingRequest(
            updateRequest.membershipId, updateRequest.updateBookingRequest);
        const bookingApiUpdateRequest = {
            token,
            updateBookingRequest,
        };
        this.fetch(this.getDataRequestSettings(JSON.stringify(bookingApiUpdateRequest)));
        this.set('bookingIsUpdated', true);
    },

    onBookingDetailDTOResponse() {
        if (this.get('bookingIsUpdated')) {
            this.displayConfirmationPage();
        }
    },

    buildUpdateBookingRequest() {
        const membershipId= this.get('postBookingMembershipId');
        const data = {
            membershipId,
            updateBookingRequest: {
                amount: genericConstants.zeroAmount,
                currency: Odigeo.Utils.Currency.currencyCode,
            },
        };
        this.set({bookingDetailDTO: null}, {silent: true});
        this.updateBooking(data);
    },

    onCreatePostBookingMember() {
        Odigeo.Utils.createCookie('ua_dimension31', 'subscriber', 30);
        tagManagement.updateDatalayer();
        if (this.get('membershipType') === genericConstants.basicMembershipType) {
            this.buildUpdateBookingRequest();
        } else {
            this.displayConfirmationPage();
        }
    },

    isMobile() {
        return Odigeo.SessionScope.flow === 'mobile';
    },

    initPageType() {
        return getEventType(this.isRegistered(), true);
    },

    trackEvent(label, register, YZB) {
        const eventInfoObj = eventConstants.eventInfoObj(this.isBasicFreeAccount(), register, YZB);
        const type = this.get('eventType');
        if (type && eventInfoObj[type] && eventInfoObj[type].action) {
            const calcLabel = label ? eventInfoObj[type].label[label] :
                eventInfoObj[type].label;
            const trackInfo = {
                category: eventInfoObj[type].category[this.isMobile() ? 'mobile' : 'desktop'],
                action: eventInfoObj[type].action,
                label: calcLabel,
            };
            trackingUtils.trackEventWithCategory(trackInfo.category, trackInfo.action, trackInfo.label);
        }
    },

    trackPage(label) {
        const type = label ? label : this.initPageType();
        const subLabelGroup = eventConstants.trackingPageLabelConfig[Odigeo.Utils.stringToCamelCase(type)][this.isBasicFreeAccount() ?
            'freePrime' : 'postbooking'];
        const subLabel = subLabelGroup ?
            ([this.isMobile() && subLabelGroup['mobile'] ? subLabelGroup.mobile : subLabelGroup.desktop])
            : null;
        if (subLabel) {
            const pageLabel = eventConstants.trackingPageLabel[this.isBasicFreeAccount() ? 'freePrime' : 'postbooking']
                + subLabel;
            trackingUtils.trackPage(pageLabel, {
                funnel: false,
            });
            tagManagement.updateDatalayer();
        }
    },

    getRecaptchaConfig() {
        this.currentAction = recaptchaPostBooking;
        this.fetch(this.getDataRequestSettings());
    },
});
